<template>
  <el-dialog
    width="60%"
    :visible.sync="$store.state.sysInit.piDiaLogVisible"
    class="dialog-data pi-dialog el-dialog__wrapper2"
    style="height: 100%"
    :modal-append-to-body="false"
    :show-close="false">
    <el-container>
      <PiDialogContactList @click-one-call="clickOneCall" />
      <el-container style="height: 722px">
        <!-- <PiDialogContactList/> -->
        <el-main class="el-main_pi">
          <div style="height: 97%">
            <el-tabs type="border-card" v-model="activeTab">
              <!-- <el-tab-pane label="サマリー" v-if="this.$store.state.sysInit.showPiButton=='ok1'"> -->
              <el-tab-pane label="サマリー" name="summary_tab">
                <template
                  v-if="
                    this.$store.state.sysInit.piCustomerInfoEmptyFlg &&
                    this.$store.state.sysInit.piIssueListEmptyFlg
                  ">
                  <div style="height: 94.2%">
                    <div style="padding-bottom: 300px"></div>
                    <p style="text-align: center; font-size: 20px">
                      左のお問い合わせ者リストから選択してください。
                      <!-- {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }} -->
                    </p>
                  </div>
                  <div style="padding: 15px"></div>
                </template>
                <template v-else>
                  <!-- サマリー・タブUI変更 #145 start-->
                  <div v-loading="this.$store.state.sysInit.piIssuesVisible" style="height: 100.8%">
                    <CTIDialogSummaryTab></CTIDialogSummaryTab>
                  </div>
                  <!-- サマリー・タブUI変更 #145 end-->
                </template>
                <div class="intrinsic-aspect-ratio-container_button_div">
                  <CallStartButton></CallStartButton>
                  <el-button type="info" size="small" plain @click="closePiDialog"
                    >閉じる</el-button
                  >
                </div>
              </el-tab-pane>
              <el-tab-pane label="応対引継ぎ情報">
                <template
                  v-if="
                    !this.$store.state.sysInit.searchDetail_unsolvedIssueListVisible &&
                    this.$store.state.sysInit.unsolvedIssueList.length == 0
                  ">
                  <div style="height: 94.2%">
                    <div style="padding-bottom: 180px"></div>
                    <p style="text-align: center; font-size: 20px">
                      {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                    </p>
                  </div>
                  <div style="padding: 15px"></div>
                </template>
                <template v-else>
                  <div
                    v-loading="this.$store.state.sysInit.searchDetail_unsolvedIssueListVisible"
                    style="height: 100.8%">
                    <CTIDialogHistoryDetailTab></CTIDialogHistoryDetailTab>
                  </div>
                </template>
                <div class="intrinsic-aspect-ratio-container_button_div">
                  <CallStartButton></CallStartButton>
                  <el-button type="info" size="small" plain @click="closePiDialog"
                    >閉じる</el-button
                  >
                </div>
              </el-tab-pane>
              <el-tab-pane label="お問い合わせ履歴">
                <template v-if="this.$store.state.sysInit.piIssueListEmptyFlg">
                  <div style="height: 96.7%">
                    <div style="padding-bottom: 180px"></div>
                    <p style="text-align: center; font-size: 20px">
                      {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                    </p>
                  </div>
                </template>

                <template v-else>
                  <div v-loading="this.$store.state.sysInit.piIssuesVisible" style="height: 97.2%">
                    <div style="padding: 5px"></div>
                    <div style="padding: 10px">
                      クレーム検知：0件　長時間通話：{{
                        this.$store.state.sysInit.longTimeCount
                      }}件　NGワード：{{ this.$store.state.sysInit.ngCount }}件
                    </div>

                    <!-- <span
                      v-for="(menu, index) in this.categoryList"
                      :key="index"
                    >
                      <span style="padding: 5px">
                        <el-tag type="success">{{ menu }}</el-tag>
                      </span>
                    </span> -->
                    <!-- <div class="customer-table"> -->
                    <el-table
                      :data="this.$store.state.sysInit.PiIssueList"
                      style="width: 98%; margin-left: 10px"
                      height="520px"
                      border
                      :cell-style="cellStyle3"
                      :header-cell-style="{
                        color: '#FFFFFF',
                        background: '#53BCE5',
                      }"
                      :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data">
                      <el-table-column width="70%" align="center">
                        <template slot="header"> # </template>
                        <template slot-scope="scope">
                          <span></span>
                          <!-- <a href="https://aicc-dev-redmine.mybluemix.net/issues/" target="_blank">{{ scope.row.issue_id }}</a> -->
                          <a
                            style="color: #5ed4ff"
                            target="_blank"
                            :href="
                              $store.state.sysInit.html_const.cons_272_redmine_url +
                              scope.row.issue_id
                            "
                            >{{ scope.row.issue_id }}</a
                          >
                        </template>
                      </el-table-column>
                      <!-- <el-table-column prop="issue_id" label="#">
                      </el-table-column> -->
                      <el-table-column
                        prop="tracker_name"
                        label="トラッカー"
                        align="center"
                        width="120%"
                        :formatter="formatTrackerName">
                      </el-table-column>
                      <el-table-column
                        prop="category_tag"
                        label="カテゴリ"
                        align="center"
                        width="160%"
                        class-name="td-is-left">
                      </el-table-column>
                      <el-table-column
                        prop="subject_name"
                        label="タイトル"
                        align="center"
                        width="180%"
                        class-name="td-is-left">
                      </el-table-column>
                      <el-table-column prop="name" label="担当者" width="115%" align="center">
                      </el-table-column>
                      <el-table-column prop="finish_time" label="作成日" width="100%" align="center">
                        <template slot-scope="scope">
                          <span>{{scope.row.finish_time.replaceAll("-","/")}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="status_name"
                        label="ステータス"
                        width="120%"
                        align="center">
                      </el-table-column>
                      <el-table-column
                        prop="response_time"
                        label="応対時間"
                        width="100%"
                        align="center">
                      </el-table-column>
                    </el-table>
                    <!-- </div> -->
                  </div>
                </template>
                <el-col :span="20" class="intrinsic-aspect-ratio-container_button_pi4">
                  <div class="intrinsic-aspect-ratio-container_button_div">
                    <CallStartButton></CallStartButton>
                    <el-button type="info" size="small" plain @click="closePiDialog"
                      >閉じる</el-button
                    >
                  </div>
                </el-col>
              </el-tab-pane>
              <el-tab-pane label="お客様情報">
                <template>
                  <template v-if="this.$store.state.sysInit.piCustomerInfoEmptyFlg">
                    <div style="height: 89%">
                      <div style="padding-bottom: 180px"></div>
                      <p style="text-align: center; font-size: 20px">
                        {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                      </p>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      v-loading="this.$store.state.sysInit.piCustomerVisible"
                      style="height: 91.8%">
                      <div style="padding: 10px"></div>

                      <div
                        style="
                          font-size: 20px;
                          background: #53bce5;
                          color: #ffffff;
                          width: 967px;
                          height: 30px;
                          padding: 5px;
                          margin-left: 10px;
                        ">
                        お客様情報
                      </div>
                      <div style="text-align: center">
                        <el-table
                          :data="this.$store.state.sysInit.customerInfo2"
                          style="width: 967px; margin-left: 9px"
                          size="medium"
                          border
                          :show-header="false"
                          :cell-style="cellStyle_1"
                          :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data">
                          <el-table-column>
                            <!-- <template slot="header">
                            <span>お客様情報</span>
                          </template> -->

                            <el-table-column prop="label" width="195"> </el-table-column>
                            <el-table-column prop="value" width="338">
                              <template slot-scope="scope">
                                <span v-if="scope.row.label=='生年月日*' || scope.row.label=='登録日' 
                                || scope.row.label=='更新日'">{{scope.row.value.replaceAll("-","/")}}</span>
                                <span v-else>{{scope.row.value}}</span>
                              </template>
                            </el-table-column>

                            <el-table-column prop="label2" width="155"> </el-table-column>
                            <el-table-column prop="value2" width="278"> </el-table-column>
                          </el-table-column>
                          <!-- <el-table-column label="お客様情報"> -->

                          <!-- </el-table-column> -->
                        </el-table>
                      </div>
                    </div>

                    <!-- <el-table-column>
                        <template slot-scope="scope">
                          <span></span>
                          {{ scope.row.label }}
                        </template>
                      </el-table-column> -->
                  </template>

                  <!-- <el-row
                      :gutter="10"
                      style="padding-left: 5px; padding-right: 0px"
                    > -->
                  <el-col :span="20" class="intrinsic-aspect-ratio-container_button_pi2">
                    <div class="intrinsic-aspect-ratio-container_button_div">
                      <CallStartButton></CallStartButton>
                      <el-button type="info" size="small" plain @click="closePiDialog"
                        >閉じる</el-button
                      >
                    </div>
                  </el-col>
                  <!-- </el-row> -->
                </template>
              </el-tab-pane>
              <el-tab-pane label="プロフ検索" name="search_page">
                <div style="padding: 10px">
                  <el-row>
                    <el-col
                      :span="24"
                      style="text-align: center"
                      v-if="this.$store.state.sysInit.isShowSearchCondition">
                      <div class="search-condition-not-expanded">
                        <span style="font-weight: bolder">検索条件</span>
                        <i
                          class="el-icon-arrow-down"
                          @click="changeShowSearchCondition"
                          style="margin-left: 15px"></i>
                      </div>
                    </el-col>
                    <el-col :span="24" style="text-align: center" v-else>
                      <div class="search-condition-expanded">
                        <span style="font-weight: bolder">検索条件</span>
                        <i
                          class="el-icon-arrow-up"
                          @click="changeShowSearchCondition"
                          style="margin-left: 15px"></i>

                        <div style="padding: 10px"></div>
                        <el-form
                          :model="this.$store.state.sysInit.searchConditionForm"
                          label-width="100px"
                          size="mini">
                          <el-row :gutter="20">
                            <el-col :span="10" style="height: 40px" :offset="1">
                              <el-form-item prop="id">
                                <span slot="label" style="position: relative; top: 8px"> ID </span>
                                <el-input
                                  v-model="$store.state.sysInit.searchConditionForm.id"
                                  style="width: 100%"
                                  disabled></el-input>
                              </el-form-item>
                            </el-col>

                            <el-col :span="10" style="height: 40px" :offset="2">
                              <el-form-item prop="name">
                                <span slot="label" style="position: relative; right: 53%; top: 8px">
                                  名前
                                </span>
                                <el-input
                                  v-model="$store.state.sysInit.searchConditionForm.name"
                                  style="width: 100%"
                                  placeholder="名前"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row :gutter="20">
                            <el-col :span="10" style="height: 40px" :offset="1">
                              <el-form-item prop="phone_number">
                                <span slot="label" style="position: relative; top: 8px">
                                  電話番号
                                </span>
                                <el-input
                                  v-model="$store.state.sysInit.searchConditionForm.phone_number"
                                  style="width: 100%"></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="10" style="height: 40px" :offset="2">
                              <el-form-item prop="email">
                                <span slot="label" style="position: relative; right: 53%; top: 8px">
                                  メールアドレス
                                </span>
                                <el-input
                                  v-model="$store.state.sysInit.searchConditionForm.email"
                                  style="width: 100%"
                                  placeholder="XXX@YYY.com"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>

                          <el-row :gutter="20">
                            <el-col :span="10" style="height: 40px" :offset="1">
                              <el-form-item prop="birthday">
                                <span slot="label" style="position: relative; top: 8px">
                                  生年月日
                                </span>
                                <el-input
                                  v-model="$store.state.sysInit.searchConditionForm.birthday"
                                  style="width: 100%"
                                  placeholder="YYYY/MM/DD"></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="10" style="height: 40px" :offset="2">
                              <el-form-item prop="address">
                                <span slot="label" style="position: relative; right: 53%; top: 8px">
                                  住所
                                </span>
                                <el-input
                                  v-model="$store.state.sysInit.searchConditionForm.address"
                                  style="width: 100%"
                                  placeholder="XX県YY市ZZ1-2-3"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row :gutter="20">
                            <el-col
                              :span="10"
                              style="position: relative; right: 95px; height: 25px">
                              <el-form-item>
                                <el-button type="primary" @click="submitSearchConditionForm()"
                                  >検索</el-button
                                >
                                <el-button @click="resetSearchConditionForm()">クリア</el-button>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-form>
                      </div>
                    </el-col>
                  </el-row>

                  <div
                    style="
                      width: 100%;
                      border-top: 1px solid #ccc;
                      z-index: 100;
                      margin-top: 10px;
                    "></div>
                  <el-row>
                    <el-col
                      :span="24"
                      style="text-align: center"
                      v-if="this.$store.state.sysInit.isShowSearchConsequence">
                      <div class="search-consequence-not-expanded">
                        <span style="font-weight: bolder">検索結果</span>
                        <i
                          class="el-icon-arrow-down"
                          @click="changeShowSearchConsequence"
                          style="margin-left: 15px"></i>
                      </div>
                    </el-col>
                    <el-col :span="24" style="text-align: center" v-else>
                      <div class="search-consequence-expanded">
                        <span style="font-weight: bolder">検索結果</span>
                        <i
                          class="el-icon-arrow-up"
                          @click="changeShowSearchConsequence"
                          style="margin-left: 15px"></i>
                      </div>
                      <div
                        style="
                          text-align: right;
                          padding-right: 15px;
                          padding-top: 10px;
                          padding-bottom: 0px;
                          font-weight: bolder;
                          font-size: 12px;
                        "
                        @click="addNewUserDialogOpen">
                        +新規顧客登錄する
                      </div>

                      <el-dialog
                        width="60%"
                        style="height: 100%"
                        class="dialog-data search-detail-dialog el-dialog__wrapper2"
                        :visible.sync="$store.state.sysInit.addNewUserDialogVisible"
                        append-to-body>
                        <span slot="title" class="el-dialog__title"> 新規顧客登錄 </span>
                        <el-tabs type="border-card">
                          <el-tab-pane label="お客様情報">
                            <div style="padding: 10px"></div>

                            <div
                              style="
                                font-size: 20px;
                                background: #53bce5;
                                color: #ffffff;
                                width: 896px;
                                height: 30px;
                                padding: 5px;
                                margin-left: 10px;
                              ">
                              お客様情報
                            </div>

                            <el-form
                              :model="this.$store.state.sysInit.newUserInfoForm"
                              label-width="100px"
                              size="mini"
                              style="position: relative; width: 950px; right: 3px">
                              <el-row :gutter="24">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> 電話番号* </span>
                                    </div>
                                    <el-input
                                      v-model="$store.state.sysInit.newUserInfoForm.phone_number"
                                      class="add-new-user-input1">
                                      <i
                                        class="el-icon-edit"
                                        slot="suffix"
                                        style="right: 5px; position: relative"></i>
                                    </el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目1 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -46px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> ID* </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input1"></el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目2 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"> </el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -92px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> 姓* </span>
                                    </div>
                                    <el-input
                                      v-model="$store.state.sysInit.newUserInfoForm.lastname"
                                      class="add-new-user-input1">
                                      <i
                                        class="el-icon-edit"
                                        slot="suffix"
                                        style="right: 5px; position: relative"></i>
                                    </el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目3 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -138px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> 名* </span>
                                    </div>
                                    <el-input
                                      v-model="$store.state.sysInit.newUserInfoForm.firstname"
                                      class="add-new-user-input1">
                                      <i
                                        class="el-icon-edit"
                                        slot="suffix"
                                        style="right: 5px; position: relative"></i>
                                    </el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目4 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -184px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> 読み* </span>
                                    </div>
                                    <el-input
                                      v-model="
                                        $store.state.sysInit.newUserInfoForm.customer_name_yomi
                                      "
                                      class="add-new-user-input1">
                                      <i
                                        class="el-icon-edit"
                                        slot="suffix"
                                        style="right: 5px; position: relative"></i>
                                    </el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目5 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -230px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> メールアドレス* </span>
                                    </div>
                                    <el-input
                                      v-model="$store.state.sysInit.newUserInfoForm.mail"
                                      class="add-new-user-input1">
                                      <i
                                        class="el-icon-edit"
                                        slot="suffix"
                                        style="right: 5px; position: relative"></i>
                                    </el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目6 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -276px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> 分類 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input1"></el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目7 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -322px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <i
                                        class="el-icon-date"
                                        style="
                                          z-index: 100;
                                          left: 380%;
                                          position: relative;
                                          color: #c2c6ce;
                                          font-size: 12px;
                                        "></i>
                                      <span slot="label" style="position: relative; right: 16px">
                                        生年月日*
                                      </span>
                                    </div>
                                    <!-- <el-input v-model="$store.state.sysInit.newUserInfoForm.birthday" class="add-new-user-input1"></el-input> -->
                                    <!-- <i class="el-input__icon" slot="prefix-icon"></i> -->
                                    <el-date-picker
                                      style="width: 98%"
                                      class="add-new-user-input1"
                                      v-model="$store.state.sysInit.newUserInfoForm.birthday"
                                      type="date"
                                      :clearable="false"
                                      prefix-icon="el-icon-platform-eleme">
                                      <!-- placeholder="日付を選択" -->
                                      <!-- <i class="el-icon-edit" slot="suffix" style="right:5px;position: relative;"></i> -->
                                      <!-- :placeholder="this.$store.state.sysInit.html_const.cons_271_add_new_customer_no_input" -->
                                    </el-date-picker>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目8 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -368px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> 性别 </span>
                                    </div>
                                    <!-- <el-input v-model="$store.state.sysInit.newUserInfoForm.sex" class="add-new-user-input1"></el-input> -->
                                    <el-select
                                      v-model="$store.state.sysInit.newUserInfoForm.sex"
                                      placeholder="選んでください"
                                      class="add-new-user-input1">
                                      <el-option
                                        v-for="item in $store.state.sysInit.newUserGenderOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                      </el-option>
                                    </el-select>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目9 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -414px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> 前住所 </span>
                                    </div>
                                    <el-input
                                      v-model="$store.state.sysInit.newUserInfoForm.former_address"
                                      class="add-new-user-input1">
                                      <i
                                        class="el-icon-edit"
                                        slot="suffix"
                                        style="right: 5px; position: relative"></i>
                                    </el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目10 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -460px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> 現住所* </span>
                                    </div>
                                    <el-input
                                      v-model="$store.state.sysInit.newUserInfoForm.current_address"
                                      class="add-new-user-input1">
                                      <i
                                        class="el-icon-edit"
                                        slot="suffix"
                                        style="right: 5px; position: relative"></i>
                                    </el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目11 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -425px; text-align: center">
                                <el-button type="primary" @click="submitNewUserForm()" size="small"
                                  >登錄</el-button
                                >
                                <el-button @click="resetNewUserForm()" size="small"
                                  >キャンセル</el-button
                                >
                              </el-row>
                            </el-form>
                          </el-tab-pane>
                        </el-tabs>
                      </el-dialog>

                      <el-table
                        v-loading="this.$store.state.sysInit.isSearchLoading"
                        :data="this.$store.state.sysInit.searchConsequence"
                        height="302px"
                        border
                        :header-cell-style="{
                          color: '#FFFFFF',
                          background: '#4DB1EC',
                        }"
                        :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data"
                        @row-click="phone_searchGetTableInfo"
                        :cell-style="searchConsequenceStyle">
                        <!-- <el-table-column label="ID" align="center"  >
  											</el-table-column> -->
                        <el-table-column label="名前" align="center">
                          <template slot-scope="scope">
		                        <span>{{ $utils.computeFullName(scope.row.lastname, scope.row.firstname) }}</span>
	                        </template>
                        </el-table-column>
                        <el-table-column prop="phone_number" label="電話番号" align="center">
                        </el-table-column>

                        <el-table-column prop="mail" label="メールアドレス" align="center">
                        </el-table-column>

                        <el-table-column
                          prop="birthday"
                          label="生年月日"
                          align="center"
                          :formatter="formatterBirthday">
                        </el-table-column>
                        <el-table-column prop="current_address" label="住所" align="center">
                        </el-table-column>
                        <el-table-column prop="" label="詳細" align="center" width="70%">
                          <template slot-scope="scope">
                            <!-- <el-button
															type="primary"
															size="small"
															plain
															@click.stop="phone_searchDetailed(scope.row)"
															>详细</el-button
														> -->
                            <!-- {{scope.row}} -->
                            <span @click.stop="phone_searchDetailed(scope.row)">
                              <img
                                src="../assets/img/search_user.png"
                                style="height: 20px; width: 20px" />
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="" label="本人確認" align="center">
                          <template slot-scope="scope">
                            <span v-if="$store.state.sysInit.talkStatus === 'start'">
                              <el-button
                                type="primary"
                                size="mini"
                                @click="phoneConfirmed(scope.row)"
                                :disabled="scope.row.is_confirmed == 1"
                                >本人確認</el-button
                              >
                            </span>
                            <span v-else>
                              <el-button
                                type="primary"
                                size="mini"
                                @click="phoneConfirmed(scope.row)"
                                disabled
                                >本人確認</el-button
                              >
                            </span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-col>
                  </el-row>
                </div>
                <div style="padding-top: 2.9%; text-align: center">
                  <CallStartButton></CallStartButton>
                  <el-button
                    v-if="this.zoiperCallButton != true"
                    disabled
                    type="info"
                    size="small"
                    plain
                    @click="phone_searchOpen"
                    >発信する</el-button
                  >
                  <el-button
                    v-if="this.zoiperCallButton == true"
                    type="primary"
                    size="small"
                    plain
                    @click="phone_searchOpen"
                    >発信する</el-button
                  >

                  <el-button type="info" size="small" plain @click="closePiDialog"
                    >閉じる</el-button
                  >
                </div>
                <!-- <SearchDetail></SearchDetail> -->
                <el-dialog
                  width="60%"
                  style="height: 100%"
                  class="dialog-data search-detail-dialog el-dialog__wrapper2"
                  :visible.sync="$store.state.sysInit.searchDetailDialogVisible"
                  append-to-body>
                  <span slot="title">
                    顧客検索 -
                    {{ this.$store.state.sysInit.searchDetailTitle.id }} :
                    {{ this.$store.state.sysInit.searchDetailTitle.name }}さん
                  </span>
                  <el-tabs type="border-card">
                    <el-tab-pane label="サマリー">
                      <template
                        v-if="
                          this.$store.state.sysInit.searchDetail_piCustomerInfoEmptyFlg &&
                          this.$store.state.sysInit.searchDetail_piIssueListEmptyFlg
                        ">
                        <div style="height: 94.2%">
                          <div style="padding-bottom: 180px"></div>
                          <p style="text-align: center; font-size: 20px">
                            {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                          </p>
                        </div>
                        <div style="padding: 15px"></div>
                      </template>
                      <template v-else>
                        <div
                          v-loading="this.$store.state.sysInit.searchDetail_piIssuesVisible"
                          style="height: 100.8%">
                          <el-row :gutter="10" style="padding-left: 10px; padding-right: 10px">
                            <el-col :span="20">
                              <div class="wrapper">
                                <div style="padding: 3px"></div>
                                <div class="intrinsic-aspect-ratio-container3"></div>
                              </div>
                            </el-col>
                          </el-row>
                          <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                            <el-col
                              :span="10"
                              class="intrinsic-aspect-ratio-container_summary_1 wrapper_border">
                              <div style="margin-top: 5px"></div>
                              <span class="pi_title_color"> お客様情報</span>
                              <br />
                              <div style="margin-top: 5px"></div>
                              <template>
                                <el-col :span="5">
                                  <img
                                    class="img_questioner1"
                                    :src="this.$store.state.sysInit.searchDetailUserLogo" />

                                  <br />
                                  <!-- <span style="margin-left: 23px">
                                    <icon name="star"></icon>
                                    <icon name="star"></icon>
                                  </span> -->
                                </el-col>
                                <el-col :span="19">
                                  <el-table
                                    :data="this.$store.state.sysInit.searchDetail_customerInfo3"
                                    style="width: 100%; font-size: 10px"
                                    height="130px"
                                    :show-header="false"
                                    :cell-style="cellStyle"
                                    :empty-text="
                                      this.$store.state.sysInit.html_const.cons_219_no_data
                                    ">
                                    <el-table-column prop="label" label="" width="100">
                                    </el-table-column>
                                    <el-table-column prop="value" label="" width="200">
                                      <template slot-scope="scope">
                                        <span v-if="scope.row.label=='生年月日*'">{{scope.row.value.replaceAll("-","/")}}</span>
                                        <span v-else>{{scope.row.value}}</span>
                                      </template>
                                    </el-table-column>
                                  </el-table>
                                </el-col>
                              </template>
                            </el-col>
                            <span v-if="this.$store.state.sysInit.searchDetail_piEmptyFlg">
                              <el-col
                                :span="10"
                                class="intrinsic-aspect-ratio-container_summary_2 wrapper_border">
                                <p style="margin-top: 50px; text-align: center; font-size: 20px">
                                  {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                                </p>
                              </el-col>
                            </span>
                            <span v-else>
                              <el-col
                                :span="10"
                                class="intrinsic-aspect-ratio-container_summary_2 wrapper_border"
                                v-if="this.$store.state.sysInit.searchDetail_similarity != 'fail'">
                                <span class="pi_title_color"
                                  >{{ this.$store.state.sysInit.user_name }}との相性診断</span
                                >
                                <br />
                                <div style="padding-left: 94px; margin-top: 5px">
                                  <div
                                    style="
                                      margin-left: 101px;
                                      font-size: 16px;
                                      color: #009193;
                                      min-height: 16px;
                                    "
                                    v-html="
                                      this.$store.state.sysInit.searchDetail_similarity
                                    "></div>
                                  <div style="display: flex">
                                    <div class="element1">
                                      <img
                                        class="element1-picture1"
                                        :src="this.$store.state.sysInit.searchDetailUserLogo" />
                                    </div>
                                    <div class="rectangle1"></div>
                                    <div
                                      id="img_head_back_searchDetail"
                                      v-bind:style="{
                                        top:
                                          54 +
                                          this.$store.state.sysInit
                                            .searchDetail_heart_change_distance +
                                          'px',
                                        height:
                                          46 -
                                          this.$store.state.sysInit
                                            .searchDetail_heart_change_distance +
                                          'px',
                                      }"></div>
                                    <img
                                      src="../assets/img/heart-white.svg"
                                      class="img_heart_searchDetail" />
                                    <div class="rectangle2"></div>
                                    <div class="element1">
                                      <img
                                        class="element1-picture2"
                                        :src="$store.state.sysInit.operator_logo" />
                                    </div>
                                  </div>
                                </div>

                                <div style="margin-bottom: 25px"></div>
                                <span v-show="this.$store.state.sysInit.searchDetail_facetFlg">
                                  <div>
                                    <span
                                      style="font-weight: bold; color: #808080; padding-left: 20px">
                                      「心配性」
                                    </span>
                                    な{{
                                      this.$store.state.sysInit.searchDetail_customer_name
                                    }}さんには<br />
                                    <span style="padding-left: 30px">{{
                                      this.$store.state.sysInit.searchDetail_advice_info
                                    }}</span>
                                  </div>
                                </span>
                              </el-col>
                              <el-col
                                :span="10"
                                class="intrinsic-aspect-ratio-container_summary_2 wrapper_border"
                                v-else>
                                <p style="margin-top: 50px; text-align: center; font-size: 20px">
                                  {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                                </p>
                              </el-col>
                            </span>
                          </el-row>
                          <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                            <el-col
                              :span="20"
                              class="intrinsic-aspect-ratio-container2_Summary_call wrapper_border">
                              <template
                                v-if="this.$store.state.sysInit.searchDetail_piIssueListEmptyFlg">
                                <p style="margin-top: 50px; text-align: center; font-size: 20px">
                                  {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                                </p>
                              </template>
                              <template v-else>
                                <div>
                                  <div>
                                    <span class="pi_title_color" style="padding-right: 25px"
                                      >お問い合わせ履歴  </span
                                    >
                                    クレーム検知：0件　長時間通話：{{
                                      this.$store.state.sysInit.searchDetail_longTimeCount
                                    }}件　NGワード：{{
                                      this.$store.state.sysInit.searchDetail_ngCount
                                    }}件

                                  </div>
                                  <div style="position: relative; padding-left: 15px">
                                    <div style="width: 825px">
                                      <span
                                        style="
                                          font-size: 10px;
                                          margin-right: 5px;
                                          color: #0000ff;
                                          min-height: 10px;
                                        ">
                                      </span>
                                    </div>
                                  </div>
                                  <el-table
                                    :data="this.$store.state.sysInit.searchDetail_PiIssueList"
                                    style="font-size: 10px"
                                    class="customer-table"
                                    border
                                    :cell-style="cellStyle2"
                                    :header-cell-style="{
                                      color: '#FFFFFF',
                                      background: '#53BCE5',
                                    }"
                                    :empty-text="
                                      this.$store.state.sysInit.html_const.cons_219_no_data
                                    ">
                                    <el-table-column width="60%" align="center">
                                      <template slot="header"> # </template>
                                      <template slot-scope="scope">
                                        <span></span>
                                        <a
                                          style="color: #5ed4ff"
                                          target="_blank"
                                          :href="
                                            $store.state.sysInit.html_const.cons_272_redmine_url +
                                            scope.row.issue_id
                                          "
                                          >{{ scope.row.issue_id }}</a
                                        >
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="subject_name"
                                      label="タイトル"
                                      align="center"
                                      class-name="td-is-left">
                                    </el-table-column>
                                    <el-table-column
                                      prop="category_tag"
                                      label="カテゴリ"
                                      align="center"
                                      class-name="td-is-left">
                                    </el-table-column>
                                    <el-table-column
                                      prop="name"
                                      label="担当者"
                                      align="center"
                                      width="90%">
                                    </el-table-column>
                                    <el-table-column
                                      prop="finish_time"
                                      label="作成日"
                                      align="center"
                                      width="80%">
                                      <template slot-scope="scope">
                                        <span>{{scope.row.finish_time.replaceAll("-","/")}}</span>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="status_name"
                                      label="ステータス"
                                      align="center"
                                      width="100%">
                                    </el-table-column>
                                  </el-table>
                                </div>
                              </template>
                            </el-col>
                          </el-row>
                          <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                            <el-col :span="20" class="intrinsic-aspect-ratio-container_button_pi1">
                            </el-col>
                          </el-row>
                        </div>
                      </template>
                      <div class="intrinsic-aspect-ratio-container_button_div">
                        <el-button type="primary" size="small" plain disabled
                          >この人で特定</el-button
                        >
                        <el-button type="info" size="small" plain @click="searchDetailDialogClose"
                          >閉じる</el-button
                        >
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="お客様情報">
                      <template>
                        <template
                          v-if="this.$store.state.sysInit.searchDetail_piCustomerInfoEmptyFlg">
                          <div style="height: 89%">
                            <div style="padding-bottom: 180px"></div>
                            <p style="text-align: center; font-size: 20px">
                              {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                            </p>
                          </div>
                        </template>
                        <template v-else>
                          <div
                            v-loading="this.$store.state.sysInit.searchDetail_piCustomerVisible"
                            style="height: 88.9%">
                            <div style="padding: 10px"></div>

                            <div
                              style="
                                font-size: 20px;
                                background: #53bce5;
                                color: #ffffff;
                                width: 896px;
                                height: 30px;
                                padding: 5px;
                                margin-left: 10px;
                              ">
                              お客様情報
                            </div>
                            <div style="text-align: center">
                              <el-table
                                :data="this.$store.state.sysInit.searchDetail_customerInfo2"
                                style="width: 896px; margin-left: 9px"
                                size="medium"
                                border
                                :show-header="false"
                                :cell-style="cellStyle_1"
                                :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data">
                                <el-table-column>
                                  <el-table-column prop="label" width="165"> </el-table-column>
                                  <el-table-column prop="value" width="281">
                                    <template slot-scope="scope">
                                      <span v-if="scope.row.label=='生年月日*' || scope.row.label=='登録日' 
                                      || scope.row.label=='更新日'">{{scope.row.value.replaceAll("-","/")}}</span>
                                      <span v-else>{{scope.row.value}}</span>
                                    </template>
                                  </el-table-column>

                                  <el-table-column prop="label2" width="165"> </el-table-column>
                                  <el-table-column prop="value2" width="282"> </el-table-column>
                                </el-table-column>
                              </el-table>
                            </div>
                          </div>
                        </template>

                        <el-col :span="20" class="intrinsic-aspect-ratio-container_button_pi2">
                          <div class="intrinsic-aspect-ratio-container_button_div">
                            <el-button type="primary" size="small" plain disabled
                              >この人で特定</el-button
                            >
                            <el-button
                              type="info"
                              size="small"
                              plain
                              @click="searchDetailDialogClose"
                              >閉じる</el-button
                            >
                          </div>
                        </el-col>
                      </template>
                    </el-tab-pane>
                    <el-tab-pane label="性格推定結果">
                      <template v-if="this.$store.state.sysInit.searchDetail_piEmptyFlg">
                        <div style="height: 100.9%">
                          <div style="padding-bottom: 180px"></div>
                          <p style="text-align: center; font-size: 20px">
                            {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                          </p>
                        </div>
                      </template>

                      <template v-else>
                        <div
                          v-loading="this.$store.state.sysInit.searchDetail_piIssuesVisible"
                          style="height: 99.5%">
                          <template v-if="this.$store.state.sysInit.searchDetail_pimessageVisible">
                            {{ this.$store.state.sysInit.searchDetail_noContentsMessage }}
                          </template>
                          <template v-else v-cloak>
                            <div style="padding: 5px"></div>
                            <el-row :gutter="10" style="padding-left: 10px; padding-right: 10px">
                              <el-col :span="20">
                                <div class="wrapper">
                                  <div class="intrinsic-aspect-ratio-container3">
                                    <span style="font-size: 16px">
                                      お問い合わせ者
                                      {{
                                        this.$store.state.sysInit.searchDetail_customer_name
                                      }}さんは
                                      <span style="font-size: 23px; font-weight: bold">
                                        「心配性」 なタイプ</span
                                      >
                                      です
                                    </span>
                                    <span
                                      style="font-size: 18px; margin-left: 20px;"
                                      :class="{
                                        veryHighPi: this.$store.state.sysInit.credibility_message.indexOf('非常に高い') > -1 , 
                                        highPi: this.$store.state.sysInit.credibility_message.indexOf('が高い') > -1 ,
                                        decentPi: this.$store.state.sysInit.credibility_message.indexOf('適正') > -1 ,
                                        lowPi: this.$store.state.sysInit.credibility_message.indexOf('低') > -1 
                                        }">
                                      {{
                                        this.$store.state.sysInit.searchDetail_credibility_message
                                      }}</span
                                    >
                                  </div>
                                </div>
                              </el-col>
                            </el-row>
                            <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                              <el-col
                                :span="10"
                                class="intrinsic-aspect-ratio-container wrapper_border">
                                <span class="pi_title_color"> 特に強い性格の傾向</span>
                                <br />
                                <div style="padding: 5px"></div>
                                <span style="display: flex; align-items: center">
                                  <span class="pi_text_color_progress">
                                    {{ this.$store.state.sysInit.searchDetail_facet_title[0] }}
                                  </span>
                                  <span style="width='300px'"></span>
                                  <div class="pi_progress">
                                    <el-progress
                                      :stroke-width="14"
                                      :percentage="
                                        $store.state.sysInit.searchDetail_facet_value[0]
                                      "></el-progress>
                                  </div>
                                  <br />
                                </span>

                                <span style="display: flex; align-items: center">
                                  <span class="pi_text_color_progress">
                                    {{ this.$store.state.sysInit.searchDetail_facet_title[1] }}
                                  </span>
                                  <div class="pi_progress">
                                    <el-progress
                                      :stroke-width="14"
                                      :percentage="
                                        $store.state.sysInit.searchDetail_facet_value[1]
                                      "></el-progress>
                                  </div>
                                  <br />
                                </span>
                                <span style="display: flex; align-items: center">
                                  <span class="pi_text_color_progress">
                                    {{ this.$store.state.sysInit.searchDetail_facet_title[2] }}
                                  </span>
                                  <div class="pi_progress">
                                    <el-progress
                                      :stroke-width="14"
                                      :percentage="
                                        $store.state.sysInit.searchDetail_facet_value[2]
                                      "></el-progress>
                                  </div>
                                  <br />
                                </span>
                              </el-col>
                              <el-col
                                :span="10"
                                class="intrinsic-aspect-ratio-container1 wrapper_border"
                                v-if="this.$store.state.sysInit.searchDetail_similarity != 'fail'">
                                <span class="pi_title_color"
                                  >{{ this.$store.state.sysInit.user_name }}との相性診断</span
                                >
                                <br />
                                <div
                                  style="
                                    margin-left: 215px;
                                    font-size: 16px;
                                    color: #009193;
                                    min-height: 16px;
                                    margin-top: 5px;
                                  "
                                  v-html="this.$store.state.sysInit.searchDetail_similarity"></div>
                                <div style="margin-left: 48px; margin-top: 10px">
                                  <div style="display: flex">
                                    <div class="element2">
                                      <img
                                        class="element2-picture1"
                                        :src="this.$store.state.sysInit.searchDetailUserLogo" />
                                    </div>
                                    <div class="rectangle2_1"></div>
                                    <div
                                      id="img_head_back2_searchDetail"
                                      v-bind:style="{
                                        top:
                                          62 +
                                          this.$store.state.sysInit
                                            .searchDetail_heart_change_distance_big +
                                          'px',
                                        height:
                                          55 -
                                          this.$store.state.sysInit
                                            .searchDetail_heart_change_distance_big +
                                          'px',
                                      }"></div>
                                    <img
                                      src="../assets/img/heart-white.svg"
                                      class="img_heart2_searchDetail" />
                                    <div class="rectangle2_2"></div>
                                    <div class="element2">
                                      <img
                                        class="element2-picture2"
                                        :src="$store.state.sysInit.operator_logo" />
                                    </div>
                                  </div>
                                  <table style="margin-top: 25px; width: 91%">
                                    <tr>
                                      <td style="width: 50px; text-align: center">
                                        <span
                                          class="pi_text_color"
                                          style="right: 33%; position: relative">
                                          {{ this.$store.state.sysInit.searchDetail_customer_name }}
                                        </span>
                                      </td>
                                      <td style="width: 50px; text-align: center">
                                        <span
                                          class="pi_text_color"
                                          style="padding-left: 50%; position: relative"
                                          >{{ this.$store.state.sysInit.user_name }}</span
                                        >
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </el-col>

                              <el-col
                                :span="10"
                                class="intrinsic-aspect-ratio-container1 wrapper_border"
                                v-else>
                                <p style="margin-top: 50px; text-align: center; font-size: 20px">
                                  {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                                </p>
                              </el-col>
                            </el-row>
                            <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                              <el-col
                                :span="20"
                                class="intrinsic-aspect-ratio-container2 wrapper_border">
                                <span class="pi_title_color"> 性格推定結果の解説</span>
                                <br />
                                <div style="padding: 7px"></div>
                                <div class="pi_text_color">
                                  {{ this.$store.state.sysInit.searchDetail_facet_message[0] }}
                                </div>
                                <div class="pi_text_color">
                                  {{ this.$store.state.sysInit.searchDetail_facet_message[1] }}
                                </div>
                                <div class="pi_text_color">
                                  {{ this.$store.state.sysInit.searchDetail_facet_message[2] }}
                                </div>
                              </el-col>
                              <el-col
                                :span="20"
                                class="intrinsic-aspect-ratio-container4 wrapper_border">
                                <span class="pi_title_color">
                                  「心配性」な{{
                                    this.$store.state.sysInit.searchDetail_customer_name
                                  }}さんの攻略法</span
                                >
                                <br />
                                <div style="padding: 7px"></div>
                                <div class="pi_text_color">
                                  {{ this.$store.state.sysInit.searchDetail_advice_info }}
                                </div>
                              </el-col>
                            </el-row>
                            <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                              <el-col
                                :span="20"
                                class="intrinsic-aspect-ratio-container_button_pi3">
                              </el-col>
                            </el-row>
                          </template>
                        </div>
                      </template>
                      <div class="intrinsic-aspect-ratio-container_button_div">
                        <el-button type="primary" size="small" plain disabled
                          >この人で特定</el-button
                        >
                        <el-button type="info" size="small" plain @click="searchDetailDialogClose"
                          >閉じる</el-button
                        >
                      </div>
                    </el-tab-pane>

                    <el-tab-pane label="お問い合わせ履歴">
                      <template v-if="this.$store.state.sysInit.searchDetail_piIssueListEmptyFlg">
                        <div style="height: 96.7%">
                          <div style="padding-bottom: 180px"></div>
                          <p style="text-align: center; font-size: 20px">
                            {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                          </p>
                        </div>
                      </template>

                      <template v-else>
                        <div
                          v-loading="this.$store.state.sysInit.searchDetail_piIssuesVisible"
                          style="height: 98.6%">
                          <div style="padding: 5px"></div>
                          <div style="padding: 10px">
                            クレーム検知：0件　長時間通話：{{
                              this.$store.state.sysInit.searchDetail_longTimeCount
                            }}件　NGワード：{{
                              this.$store.state.sysInit.searchDetail_ngCount
                            }}件
                          </div>
                          <el-table
                            :data="this.$store.state.sysInit.searchDetail_PiIssueList"
                            style="width: 97%; margin-left: 10px"
                            height="520px"
                            border
                            :cell-style="cellStyle3"
                            :header-cell-style="{
                              color: '#FFFFFF',
                              background: '#53BCE5',
                            }"
                            :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data">
                            <el-table-column width="65%" align="center">
                              <template slot="header"> # </template>
                              <template slot-scope="scope">
                                <span></span>
                                <a
                                  style="color: #5ed4ff"
                                  target="_blank"
                                  :href="
                                    $store.state.sysInit.html_const.cons_272_redmine_url +
                                    scope.row.issue_id
                                  "
                                  >{{ scope.row.issue_id }}</a
                                >
                              </template>
                            </el-table-column>

                            <el-table-column
                              prop="tracker_name"
                              label="トラッカー"
                              align="center"
                              width="120%">
                            </el-table-column>
                            <el-table-column
                              prop="category_tag"
                              label="カテゴリ"
                              align="center"
                              width="160%"
                              class-name="td-is-left">
                            </el-table-column>
                            <el-table-column
                              prop="subject_name"
                              label="タイトル"
                              align="center"
                              width="159%"
                              class-name="td-is-left">
                            </el-table-column>
                            <el-table-column prop="name" label="担当者" width="100%" align="center">
                            </el-table-column>
                            <el-table-column
                              prop="finish_time"
                              label="作成日"
                              width="80%"
                              align="center">
                              <template slot-scope="scope">
                                <span>{{scope.row.finish_time.replaceAll("-","/")}}</span>
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="status_name"
                              label="ステータス"
                              width="120%"
                              align="center">
                            </el-table-column>
                            <el-table-column
                              prop="response_time"
                              label="応対時間"
                              width="80%"
                              align="center">
                            </el-table-column>
                          </el-table>
                        </div>
                      </template>
                      <el-col :span="20" class="intrinsic-aspect-ratio-container_button_pi4">
                        <div class="intrinsic-aspect-ratio-container_button_div">
                          <el-button type="primary" size="small" plain disabled
                            >この人で特定</el-button
                          >
                          <el-button type="info" size="small" plain @click="searchDetailDialogClose"
                            >閉じる</el-button
                          >
                        </div>
                      </el-col>
                    </el-tab-pane>
                    <el-tab-pane label="...">........</el-tab-pane>
                  </el-tabs>
                </el-dialog>
              </el-tab-pane>
              <el-tab-pane label="性格推定結果">
                <template v-if="this.$store.state.sysInit.piEmptyFlg">
                  <div style="height: 100.9%">
                    <div style="padding-bottom: 180px"></div>
                    <p style="text-align: center; font-size: 20px">
                      {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                    </p>
                  </div>
                </template>

                <template v-else>
                  <div v-loading="this.$store.state.sysInit.piIssuesVisible" style="height: 101%">
                    <template v-if="this.$store.state.sysInit.pimessageVisible">
                      {{ this.$store.state.sysInit.noContentsMessage }}
                    </template>
                    <template v-else v-cloak>
                      <div style="padding: 5px"></div>
                      <el-row :gutter="10" style="padding-left: 10px; padding-right: 10px">
                        <el-col :span="20">
                          <div class="wrapper">
                            <div class="intrinsic-aspect-ratio-container3">
                              <span style="font-size: 16px">
                                お問い合わせ者
                                {{ this.$store.state.sysInit.customer_name }}さんは
                                <span style="font-size: 23px; font-weight: bold">
                                  「心配性」 なタイプ</span
                                >
                                です
                              </span>
                              <!-- <span style="font-size: 18px;margin-left: 12px;"> -->
                              <span style="font-size: 18px; margin-left: 20px; "
                                :class="{
                                  veryHighPi: this.$store.state.sysInit.credibility_message.indexOf('非常に高い') > -1 , 
                                  highPi: this.$store.state.sysInit.credibility_message.indexOf('が高い') > -1 ,
                                  decentPi: this.$store.state.sysInit.credibility_message.indexOf('適正') > -1 ,
                                  lowPi: this.$store.state.sysInit.credibility_message.indexOf('低') > -1 
                                  }">
                                {{ this.$store.state.sysInit.credibility_message }}</span
                              >
                              <!-- </span> -->
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                        <!-- <el-col :span="10" class="intrinsic-aspect-ratio-container wrapper_border"> -->
                        <el-col :span="10" class="intrinsic-aspect-ratio-container wrapper_border">
                          <span class="pi_title_color"> 特に強い性格の傾向</span>
                          <br />
                          <div style="padding: 5px"></div>
                          <span style="display: flex; align-items: center">
                            <span class="pi_text_color_progress">
                              {{ this.$store.state.sysInit.facet_title[0] }}
                            </span>
                            <span style="width='300px'"></span>
                            <div class="pi_progress">
                              <el-progress
                                :stroke-width="14"
                                :percentage="$store.state.sysInit.facet_value[0]"></el-progress>
                            </div>
                            <br />
                          </span>

                          <span style="display: flex; align-items: center">
                            <span class="pi_text_color_progress">
                              {{ this.$store.state.sysInit.facet_title[1] }}
                            </span>
                            <div class="pi_progress">
                              <el-progress
                                :stroke-width="14"
                                :percentage="$store.state.sysInit.facet_value[1]"></el-progress>
                            </div>
                            <br />
                          </span>
                          <span style="display: flex; align-items: center">
                            <span class="pi_text_color_progress">
                              {{ this.$store.state.sysInit.facet_title[2] }}
                            </span>
                            <div class="pi_progress">
                              <el-progress
                                :stroke-width="14"
                                :percentage="$store.state.sysInit.facet_value[2]"></el-progress>
                            </div>
                            <br />
                          </span>
                          <!-- {{ this.facet_title }} -->
                        </el-col>
                        <!-- <el-col :span="10" class="intrinsic-aspect-ratio-container1 wrapper_border"> -->
                        <el-col
                          :span="10"
                          class="intrinsic-aspect-ratio-container1 wrapper_border"
                          v-if="this.$store.state.sysInit.similarity != 'fail'">
                          <span class="pi_title_color"
                            >{{ this.$store.state.sysInit.user_name }}との相性診断</span
                          >
                          <br />
                          <div
                            style="
                              margin-left: 216px;
                              font-size: 16px;
                              color: #009193;
                              min-height: 16px;
                              margin-top: 5px;
                            "
                            v-html="this.$store.state.sysInit.similarity">
                            <!-- 90% -->
                            <!-- {{this.$store.state.sysInit.similarity}} -->
                          </div>
                          <div style="margin-left: 75px; margin-top: 10px">
                            <div style="display: flex">
                              <div class="element2">
                                <img
                                  class="element2-picture1"
                                  :src="this.$store.state.sysInit.pi_phone_questioner_logo" />
                              </div>
                              <div class="rectangle2_1"></div>
                              <div
                                id="img_head_back2"
                                v-bind:style="{
                                  top:
                                    62 + this.$store.state.sysInit.heart_change_distance_big + 'px',
                                  height:
                                    55 - this.$store.state.sysInit.heart_change_distance_big + 'px',
                                }"></div>
                              <img src="../assets/img/heart-white.svg" class="img_heart2" />
                              <div class="rectangle2_2"></div>
                              <div class="element2">
                                <img
                                  class="element2-picture2"
                                  :src="$store.state.sysInit.operator_logo" />
                              </div>
                            </div>
                            <table style="margin-top: 25px; width: 91%">
                              <tr>
                                <td style="width: 50px; text-align: center">
                                  <span
                                    class="pi_text_color"
                                    style="right: 33%; position: relative">
                                    {{ this.$store.state.sysInit.customer_name }}
                                  </span>
                                </td>
                                <td style="width: 50px; text-align: center">
                                  <span
                                    class="pi_text_color"
                                    style="padding-left: 16%; position: relative"
                                    >{{ this.$store.state.sysInit.user_name }}</span
                                  >
                                </td>
                              </tr>
                            </table>
                          </div>
                        </el-col>

                        <el-col
                          :span="10"
                          class="intrinsic-aspect-ratio-container1 wrapper_border"
                          v-else>
                          <p style="margin-top: 50px; text-align: center; font-size: 20px">
                            {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                          </p>
                        </el-col>
                      </el-row>
                      <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                        <!-- <el-col :span="20" class="intrinsic-aspect-ratio-container2 wrapper_border"> -->
                        <el-col :span="20" class="intrinsic-aspect-ratio-container2 wrapper_border">
                          <span class="pi_title_color"> 性格推定結果の解説</span>
                          <br />
                          <div style="padding: 7px"></div>
                          <div class="pi_text_color">
                            {{ this.$store.state.sysInit.facet_message[0] }}
                          </div>
                          <div class="pi_text_color">
                            {{ this.$store.state.sysInit.facet_message[1] }}
                          </div>
                          <div class="pi_text_color">
                            {{ this.$store.state.sysInit.facet_message[2] }}
                          </div>
                        </el-col>
                        <el-col :span="20" class="intrinsic-aspect-ratio-container4 wrapper_border">
                          <span class="pi_title_color">
                            「心配性」な{{
                              this.$store.state.sysInit.customer_name
                            }}さんの攻略法</span
                          >
                          <br />
                          <div style="padding: 7px"></div>
                          <div class="pi_text_color">
                            {{ this.$store.state.sysInit.advice_info }}
                          </div>
                          <!-- {{ this.advice_info }} -->
                        </el-col>
                      </el-row>
                      <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                        <el-col :span="20" class="intrinsic-aspect-ratio-container_button_pi3">
                        </el-col>
                      </el-row>
                    </template>
                  </div>
                </template>
                <div class="intrinsic-aspect-ratio-container_button_div">
                  <CallStartButton></CallStartButton>
                  <el-button type="info" size="small" plain @click="closePiDialog"
                    >閉じる</el-button
                  >
                </div>
              </el-tab-pane>

              <el-tab-pane label="...">........</el-tab-pane>
            </el-tabs>
          </div></el-main
        >
        <!-- <el-footer>Footer</el-footer> -->
      </el-container>
    </el-container>

    <span slot="title" class="dialog-header">
      <span class="el-dialog__title">お問い合わせ者情報</span>
      <button type="button" class="el-dialog__headerbtn header-minbtn" @click="closePiDialog">
        <i class="el-icon-minus" style="color: white"></i>
      </button>
      <button type="button" class="el-dialog__headerbtn" @click="closePiDialog">
        <i class="el-icon-close" style="color: white"></i>
      </button>
    </span>
  </el-dialog>
</template>

<script>
import VueUtils from '@/utils/utils.js';
import { Message } from "element-ui";
import CallStartButton from "./CallStartButton.vue";
import PiDialogContactList from "./PiDialogContactList.vue";
import CTIDialogHistoryDetailTab from "./CTIDialogHistoryDetailTab.vue";
import CTIDialogSummaryTab from "./CTIDialogSummaryTab.vue";
var sd = require("silly-datetime");
import { orderBy, findIndex, reverse, sortBy, toPairs, find, chunk, remove, omit } from "lodash";
import moment from "moment";
export default {
  components: {
    CallStartButton,
    PiDialogContactList,
    CTIDialogHistoryDetailTab,
    CTIDialogSummaryTab,
  },
  data() {
    return {
      categoryList: [],
      piRecordInfo: "",
      timerWaiting: "",
      timerChating: "",
      timerEnding: "",
      activeTab: "summary_tab",
      zoiperCallButton: false,
    };
  },
  watch: {
    "$store.state.sysInit.phone_ChatingSortByTimeFlg": function () {
      this.phone_ChatingSortByTime();
    },
    "$store.state.sysInit.phone_WaitingSortByTimeFlg": function () {
      this.phone_waitingSortByTime();
    },
    "$store.state.sysInit.phone_EndingSortByTimeFlg": function () {
      this.phone_endingSortByTime();
    },
  },
  // computed:{
  // },
  mounted: function () {
    var _this = this;
    this.timerWaiting = setInterval(function () {
      for (let data of _this.$store.state.sysInit.piCallInfoObj.pi_waiting) {
        if (data.startTime) {
          let timezone = 9;
          let offset_GMT = new Date().getTimezoneOffset();
          let nowDate = new Date().getTime();
          let time = sd.format(
            new Date(nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000),
            "YYYY-MM-DD HH:mm:ss"
          );
          var startTime = moment(
            new Date(data.startTime.replace(/T/g, " ").replace(/\.[\d]{3}Z/, ""))
          ).format("YYYY-MM-DD HH:mm:ss");
          let outTime = "";
          let hoursTime = "";
          let minutesTime = "";
          let secondsTime = "";
          let hours = moment(time).diff(moment(startTime), "hours");
          if (hours > 0) {
            if (hours < 10) {
              hoursTime = hoursTime + "0" + hours + "時";
            } else {
              hoursTime = hoursTime + hours + "時";
            }
          } else {
            hoursTime = hoursTime + "00時";
          }
          let minutes = moment(time).diff(moment(startTime), "minutes") % 60;
          if (minutes > 0) {
            if (minutes < 10) {
              minutesTime = minutesTime + "0" + minutes + "分";
            } else {
              minutesTime = minutesTime + minutes + "分";
            }
          } else {
            minutesTime = minutesTime + "00分";
          }
          let seconds = (moment(time).diff(moment(startTime), "seconds") % 60) % 60;
          if (seconds > 0) {
            if (seconds < 10) {
              secondsTime = secondsTime + "0" + seconds + "秒";
            } else {
              secondsTime = secondsTime + seconds + "秒";
            }
          } else {
            secondsTime = secondsTime + "00秒";
          }
          if (hours > 0) {
            outTime = hoursTime + "前";
          } else if (minutes > 0) {
            outTime = minutesTime + "前";
          } else if (seconds > 0) {
            outTime = secondsTime + "前";
          }
          data.time = outTime;
        }
      }
    }, 1000);
    this.timerChating = setInterval(function () {
      for (let data of _this.$store.state.sysInit.piCallInfoObj.pi_calling) {
        if (data.startTime) {
          let timezone = 9;
          let offset_GMT = new Date().getTimezoneOffset();
          let nowDate = new Date().getTime();
          let time = sd.format(
            new Date(nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000),
            "YYYY-MM-DD HH:mm:ss"
          );
          var startTime = moment(
            new Date(data.startTime.replace(/T/g, " ").replace(/\.[\d]{3}Z/, ""))
          ).format("YYYY-MM-DD HH:mm:ss");
          let outTime = "";
          let hoursTime = "";
          let minutesTime = "";
          let secondsTime = "";
          let hours = moment(time).diff(moment(startTime), "hours");
          if (hours > 0) {
            if (hours < 10) {
              hoursTime = hoursTime + "0" + hours + "時";
            } else {
              hoursTime = hoursTime + hours + "時";
            }
          } else {
            hoursTime = hoursTime + "00時";
          }
          let minutes = moment(time).diff(moment(startTime), "minutes") % 60;
          if (minutes > 0) {
            if (minutes < 10) {
              minutesTime = minutesTime + "0" + minutes + "分";
            } else {
              minutesTime = minutesTime + minutes + "分";
            }
          } else {
            minutesTime = minutesTime + "00分";
          }
          let seconds = (moment(time).diff(moment(startTime), "seconds") % 60) % 60;
          if (seconds > 0) {
            if (seconds < 10) {
              secondsTime = secondsTime + "0" + seconds + "秒";
            } else {
              secondsTime = secondsTime + seconds + "秒";
            }
          } else {
            secondsTime = secondsTime + "00秒";
          }
          if (hours > 0) {
            outTime = hoursTime + "前";
          } else if (minutes > 0) {
            outTime = minutesTime + "前";
          } else if (seconds > 0) {
            outTime = secondsTime + "前";
          }
          data.time = outTime;
        }
      }
    }, 1000);
    this.timerEnding = setInterval(function () {
      for (let data of _this.$store.state.sysInit.piRecordInfoObj.piRecordInfo) {
        if (data && data.call_end_time) {
          let timezone = 9;
          let offset_GMT = new Date().getTimezoneOffset();
          let nowDate = new Date().getTime();
          let time = sd.format(
            new Date(nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000),
            "YYYY-MM-DD HH:mm:ss"
          );
          var startTime = moment(
            new Date(data.call_end_time.replace(/T/g, " ").replace(/\.[\d]{3}Z/, ""))
          ).format("YYYY-MM-DD HH:mm:ss");
          let outTime = "";
          let hoursTime = "";
          let minutesTime = "";
          let secondsTime = "";
          let hours = moment(time).diff(moment(startTime), "hours");
          if (hours > 0) {
            if (hours < 10) {
              hoursTime = hoursTime + "0" + hours + "時";
            } else {
              hoursTime = hoursTime + hours + "時";
            }
          } else {
            hoursTime = hoursTime + "00時";
          }
          let minutes = moment(time).diff(moment(startTime), "minutes") % 60;
          if (minutes > 0) {
            if (minutes < 10) {
              minutesTime = minutesTime + "0" + minutes + "分";
            } else {
              minutesTime = minutesTime + minutes + "分";
            }
          } else {
            minutesTime = minutesTime + "00分";
          }
          let seconds = (moment(time).diff(moment(startTime), "seconds") % 60) % 60;
          if (seconds > 0) {
            if (seconds < 10) {
              secondsTime = secondsTime + "0" + seconds + "秒";
            } else {
              secondsTime = secondsTime + seconds + "秒";
            }
          } else {
            secondsTime = secondsTime + "00秒";
          }
          if (hours > 0) {
            outTime = hoursTime + "前";
          } else if (minutes > 0) {
            outTime = minutesTime + "前";
          } else if (seconds > 0) {
            outTime = secondsTime + "前";
          }
          data.time = outTime;
        }
      }
    }, 1000);
  },
  beforeDestroy: function () {
    if (this.timerWaiting) {
      clearInterval(this.timerWaiting);
    }
    if (this.timerChating) {
      clearInterval(this.timerChating);
    }
    if (this.timerEnding) {
      clearInterval(this.timerEnding);
    }
  },

  methods: {
    formatTrackerName(row) {
      switch (row.tracker_name) {
        case "AI ASSISTANT":
          return "オペレーターによる電話受付対応";
        case "AI VOICEBOT":
          return "AI VOICEBOT";
        case "AI CHATBOT":
          return "AI CHATBOT";
        default:
          return row.tracker_name; // 其他情况就显示原值
      }
    },
    formatterBirthday(row) {
      return row.birthday ? row.birthday.split("T")[0].replaceAll("-","/") : "";
    },
    closePiDialog() {
      this.$store.state.sysInit.piDiaLogVisible = false;
      _.forEach(this.$store.state.sysInit.searchConsequence, function (value, key) {
        value.searchIsChecked = false;
      });
      this.zoiperCallButton = false;
      this.$store.state.sysInit.searchConsequence.sort();
      if (this.$store.state.sysInit.piCallInfoObj.pi_waiting.length > 0) {
        this.$store.state.sysInit.isBlingFlg_call = true;
      } else {
        this.$store.state.sysInit.isBlingFlg_call = false;
      }
    },
    handleChange(val) {
      console.log(val);
    },

    getAllInfoToPi_call(row, event, colum) {
      this.$store.state.store_sv.phone_sv_help_status = "iscalling";
      console.log(row);
      row.current_calling = true;
      let val = row.Tnumber ? row.Tnumber : row.telNum;
      this.$store.state.sysInit.searchConditionForm.phone_number = val;
      this.$store.dispatch("sysInit/searchByCondition", {
        params: this.$store.state.sysInit.searchConditionForm,
      });
      // this.$store.state.sysInit.phone_questioner_name = row.customerName;
      this.$store.state.sysInit.pi_phone_questioner_logo = row.logo_url;
      // console.log("this.$store.state.sysInit.phone_questioner_logo",this.$store.state.sysInit.phone_questioner_logo)
      // console.log("this.$store.state.sysInit.phone_questioner_name",this.$store.state.sysInit.phone_questioner_name)
      this.$store.dispatch("sysInit/getAllInfoToPi", {
        telNum: val,
      });
      this.categoryList = [];
      this.$store.state.sysInit.pi_loading = true;
      this.$store.state.sysInit.piIssuesVisible = true;
      this.$store.state.sysInit.piCustomerVisible = true;
      // this.$store.state.sysInit.piCallWaitVisible = true;
      // this.$store.state.sysInit.piRecordVisible = true;
    },
    getAllInfoToPi(row, event, colum) {
      // $store.state.sysInit.piCallInfoObj.pi_waiting
      _.forEach(this.$store.state.sysInit.piCallInfoObj.pi_waiting, function (value, key) {
        value.current_waiting = false;
      });
      row.current_waiting = true;
      this.$store.state.store_sv.phone_sv_help_status = "isWaiting";
      console.log(row);
      this.$store.state.sysInit.pi_phone_questioner_logo = row.logo_url;
      let val = row.Tnumber ? row.Tnumber : row.telNum;
      this.$store.state.sysInit.searchConditionForm.phone_number = val;
      this.$store.dispatch("sysInit/searchByCondition", {
        params: this.$store.state.sysInit.searchConditionForm,
      });
      this.$store.dispatch("sysInit/getAllInfoToPi", {
        telNum: val,
      });
      this.categoryList = [];
      this.$store.state.sysInit.pi_loading = true;
      this.$store.state.sysInit.piIssuesVisible = true;
      this.$store.state.sysInit.piCustomerVisible = true;
      this.$store.state.sysInit.disabledCallButton = false;
      // this.$store.state.sysInit.piCallWaitVisible = true;
      // this.$store.state.sysInit.piRecordVisible = true;
    },
    getAllInfoToPi_end(row, event, colum) {
      _.forEach(this.$store.state.sysInit.piRecordInfoObj.piRecordInfo, function (value, key) {
        value.current_ending = false;
      });
      row.current_ending = true;
      this.$store.state.store_sv.phone_sv_help_status = "isEnd";
      let val = row.Tnumber ? row.Tnumber : row.telnum;
      this.$store.state.sysInit.pi_phone_questioner_logo = row.logo_url;
      this.$store.dispatch("sysInit/getAllInfoToPi", {
        telNum: val,
      });
      this.categoryList = [];
      this.$store.state.sysInit.pi_loading = true;
      this.$store.state.sysInit.piIssuesVisible = true;
      this.$store.state.sysInit.piCustomerVisible = true;
      // this.$store.state.sysInit.piCallWaitVisible = true;
      // this.$store.state.sysInit.piRecordVisible = true;
    },

    showCategoryById(row, event, colum) {
      console.log("row", typeof row.category_tag, row);
      let temp_categoryList = row.category_tag.split(/\s+/g);
      console.log("temp_categoryList", temp_categoryList);
      let temp_categoryList2 = [];
      for (let i of temp_categoryList) {
        if (i) {
          temp_categoryList2.push(i);
        }
      }
      this.categoryList = temp_categoryList2;
      console.log("categoryList", this.categoryList);
    },

    cellStyle({ row, column, rowIndex, columnIndex }) {
      // console.log("columnIndex", columnIndex);
      if (columnIndex === 0) {
        //指定坐标rowIndex ：行，columnIndex ：列
        return "background:#53BCE5 ; color:#FFFFFF;padding-left:5px";
      } else if (columnIndex === 1) {
        if (rowIndex % 2 == 1) {
          return "height:20px;background:#E6E6E6;font-weight:normal;padding-left:5px ";
        } else {
          return "height:20px;background:#F2F2F2;font-weight:normal;padding-left:5px ";
        }
      }
      // else {
      //   return "height:20px;background:#E6E6E6";
      // }
    },
    cellStyle_1({ row, column, rowIndex, columnIndex }) {
      // console.log("columnIndex", columnIndex);
      if (columnIndex === 0) {
        //指定坐标rowIndex ：行，columnIndex ：列
        return "color:#FFFFFF;background:#53BCE5";
      } else if (columnIndex === 2) {
        return "color:#FFFFFF;height:30px;background:#53BCE5;padding-left:10px";
      } else if (columnIndex === 1) {
        if (rowIndex % 2 == 1) {
          return "height:20px;background:#E6E6E6;font-weight:normal;padding-left:5px ";
        } else {
          return "height:20px;background:#F2F2F2;font-weight:normal;padding-left:5px ";
        }
        // return "height:30px;background:#E6E6E6";
      } else {
        if (rowIndex % 2 == 1) {
          return "height:20px;background:#E6E6E6;font-weight:normal;padding-left:5px ";
        } else {
          return "height:20px;background:#F2F2F2;font-weight:normal;padding-left:5px ";
        }
      }
    },
    searchConsequenceStyle({ row, column, rowIndex, columnIndex }) {
      console.log(row);
      if (row.searchIsChecked) {
        return "background:#FFEAEA;";
      }
    },

    cellStyle2({ row, column, rowIndex, columnIndex }) {
      // console.log("columnIndex", columnIndex);
      if (rowIndex === 0) {
        //指定坐标rowIndex ：行，columnIndex ：列

        if (this.$store.state.sysInit.piIssueStatusFlg) {
          return "background:#F2F2F2;";
        } else {
          return "background:#F2F2F2";
        }
      } else if (rowIndex % 2 == 1) {
        return "background:#E6E6E6";
      } else {
        return "background:#F2F2F2";
      }
    },
    cellStyle3({ row, column, rowIndex, columnIndex }) {
      // console.log("columnIndex", columnIndex);
      if (rowIndex % 2 == 1) {
        //指定坐标rowIndex ：行，columnIndex ：列
        return "background:#E6E6E6";
      } else {
        return "background:#F2F2F2";
      }
    },
    //       cellStyle_search_consequence({ row, column, rowIndex, columnIndex }){
    // if (rowIndex === 0) {
    //   return "background:#F2F2F2;color:#0000FF";
    // }
    //   },

    changeShowSearchCondition() {
      this.$store.state.sysInit.isShowSearchCondition =
        !this.$store.state.sysInit.isShowSearchCondition;
    },
    changeShowSearchConsequence() {
      this.$store.state.sysInit.isShowSearchConsequence =
        !this.$store.state.sysInit.isShowSearchConsequence;
    },

    submitSearchConditionForm() {
      this.$store.state.sysInit.isSearchLoading = true;
      console.log(this.$store.state.sysInit.searchConditionForm);
      this.$store.dispatch("sysInit/searchByCondition", {
        params: this.$store.state.sysInit.searchConditionForm,
      });
      this.zoiperCallButton = false;

      // searchByCondition
    },
    resetSearchConditionForm() {
      this.$store.state.sysInit.searchConditionForm.id = "";
      this.$store.state.sysInit.searchConditionForm.name = "";
      this.$store.state.sysInit.searchConditionForm.phone_number = "";
      this.$store.state.sysInit.searchConditionForm.email = "";
      this.$store.state.sysInit.searchConditionForm.birthday = "";
      this.$store.state.sysInit.searchConditionForm.address = "";
    },
    phone_searchOpen() {
      // window.open("zoiper://" + this.$store.state.sysInit.currentPhoneUserInfo.phone_number);
      // if(!this.$store.state.phone.currentCallerNum && !this.$store.state.phone.inCallList.length){
      //   console.log(this.$store.state.sysInit.currentPhoneUserInfo.phone_number);
      // }
      this.$SIP.DialByLine("audio", null, this.$store.state.sysInit.currentPhoneUserInfo.phone_number);
			this.$store.commit('phone/setCurrentCallerNum', this.$store.state.sysInit.currentPhoneUserInfo.phone_number)
      this.$store.dispatch('phone/setShowPhone', true)
    },  

    phone_searchGetTableInfo(row, event, colum) {
      _.forEach(this.$store.state.sysInit.searchConsequence, function (value, key) {
        value.searchIsChecked = false;
      });
      console.log(this.$store.state.sysInit.searchConsequence);
      row.searchIsChecked = true;
      this.$store.state.sysInit.searchConsequence.sort();
      this.$store.state.sysInit.currentPhoneUserInfo.phone_number = row.phone_number;
      if (this.$store.state.sysInit.talkStatus != "start") {
        this.zoiperCallButton = true;
      }
      console.log(row);
    },
    phone_searchDetailed(row) {
      this.$store.state.sysInit.searchDetail_pi_loading = true;
      this.$store.state.sysInit.searchDetail_piIssuesVisible = true;
      this.$store.state.sysInit.searchDetail_piCustomerVisible = true;

      if (row.logo_url) {
        this.$store.state.sysInit.searchDetailUserLogo = row.logo_url;
      } else {
        this.$store.state.sysInit.searchDetailUserLogo = this.$store.state.sysInit.questioner_logo;
      }

      this.$store.state.sysInit.searchDetailTitle.name = row.customer_name;
      this.$store.state.sysInit.searchDetailTitle.id = row.id;
      this.$store.state.sysInit.searchDetailDialogVisible = true;
      let val = row.phone_number;
      this.$store.dispatch("sysInit/searchDetail_getAllInfoToPi", {
        telNum: val,
      });
      console.log(row);
    },
    searchDetailDialogClose() {
      this.$store.state.sysInit.searchDetailDialogVisible = false;
    },

    addNewUserDialogOpen() {
      this.$store.state.sysInit.addNewUserDialogVisible = true;
    },
    addNewUserDialogClose() {
      this.$store.state.sysInit.newUserInfoForm.phone_number = "";
      this.$store.state.sysInit.newUserInfoForm.firstname = "";
      this.$store.state.sysInit.newUserInfoForm.lastname = "";
      this.$store.state.sysInit.newUserInfoForm.mail = "";
      this.$store.state.sysInit.newUserInfoForm.sex = "";
      this.$store.state.sysInit.newUserInfoForm.birthday = "";
      this.$store.state.sysInit.newUserInfoForm.former_address = "";
      this.$store.state.sysInit.newUserInfoForm.current_address = "";
      this.$store.state.sysInit.newUserInfoForm.customer_name_yomi = "";
      this.$store.state.sysInit.addNewUserDialogVisible = false;
    },
    resetNewUserForm() {
      this.$store.state.sysInit.newUserInfoForm.phone_number = "";
      this.$store.state.sysInit.newUserInfoForm.firstname = "";
      this.$store.state.sysInit.newUserInfoForm.lastname = "";
      this.$store.state.sysInit.newUserInfoForm.mail = "";
      this.$store.state.sysInit.newUserInfoForm.sex = "";
      this.$store.state.sysInit.newUserInfoForm.birthday = "";
      this.$store.state.sysInit.newUserInfoForm.former_address = "";
      this.$store.state.sysInit.newUserInfoForm.current_address = "";
      this.$store.state.sysInit.newUserInfoForm.customer_name_yomi = "";
      this.$store.state.sysInit.addNewUserDialogVisible = false;
    },
    submitNewUserForm() {
      console.log(this.$store.state.sysInit.newUserInfoForm);

      if (
        this.$store.state.sysInit.newUserInfoForm.phone_number &&
        this.$store.state.sysInit.newUserInfoForm.firstname &&
        this.$store.state.sysInit.newUserInfoForm.lastname &&
        this.$store.state.sysInit.newUserInfoForm.customer_name_yomi &&
        this.$store.state.sysInit.newUserInfoForm.mail &&
        this.$store.state.sysInit.newUserInfoForm.birthday &&
        this.$store.state.sysInit.newUserInfoForm.current_address
      ) {
        this.$store.dispatch("sysInit/addNewUser", {
          params: this.$store.state.sysInit.newUserInfoForm,
        });
      } else {
        Message.warning({
          message: this.$store.state.sysInit.html_const.cons_270_add_new_customer_warning_message,
        });
      }
    },

    phone_ChatingSortByTime() {
      if (this.$store.state.sysInit.phone_ChatingSortByTimeFlg) {
        // this.$store.state.sysInit.piCallInfoObj.pi_calling =  orderBy(this.$store.state.sysInit.piCallInfoObj.pi_calling,['startTime'],['desc']);
        this.$store.state.sysInit.piCallInfoObj.pi_calling = sortBy(
          this.$store.state.sysInit.piCallInfoObj.pi_calling,
          function (o) {
            return o.startTime;
          }
        ).reverse();
      } else {
        this.$store.state.sysInit.piCallInfoObj.pi_calling = orderBy(
          this.$store.state.sysInit.piCallInfoObj.pi_calling,
          ["similarity"],
          ["desc"]
        );
      }
    },
    phone_waitingSortByTime() {
      if (this.$store.state.sysInit.phone_WaitingSortByTimeFlg) {
        // this.$store.state.sysInit.piCallInfoObj.pi_waiting =   orderBy(this.$store.state.sysInit.piCallInfoObj.pi_waiting,['startTime'],['desc']);
        this.$store.state.sysInit.piCallInfoObj.pi_waiting = sortBy(
          this.$store.state.sysInit.piCallInfoObj.pi_waiting,
          function (o) {
            return o.startTime;
          }
        ).reverse();
      } else {
        this.$store.state.sysInit.piCallInfoObj.pi_waiting = orderBy(
          this.$store.state.sysInit.piCallInfoObj.pi_waiting,
          ["similarity"],
          ["desc"]
        );
      }
    },
    phone_endingSortByTime() {
      if (this.$store.state.sysInit.phone_EndingSortByTimeFlg) {
        console.log(typeof this.$store.state.sysInit.piRecordInfoObj.piRecordInfo);
        this.$store.state.sysInit.piRecordInfoObj.piRecordInfo.forEach(function (val, index) {
          console.log(val, index);
        });

        // this.$store.state.sysInit.piRecordInfoObj.piRecordInfo =   orderBy(this.$store.state.sysInit.piRecordInfoObj.piRecordInfo,['call_end_time'],['asc']);
        this.$store.state.sysInit.piRecordInfoObj.piRecordInfo = sortBy(
          this.$store.state.sysInit.piRecordInfoObj.piRecordInfo,
          function (o) {
            return o.call_end_time;
          }
        ).reverse();
      } else {
        this.$store.state.sysInit.piRecordInfoObj.piRecordInfo = orderBy(
          this.$store.state.sysInit.piRecordInfoObj.piRecordInfo,
          ["similarity"],
          ["desc"]
        );
      }
    },
    phoneConfirmed(userInfo) {
      this.$store.dispatch("sysInit/changeCustomerInfoConfirm", {
        params: userInfo.phone_number,
      });
      userInfo.is_confirmed = 1;
    },

    dropdownSort_phone(command) {
      // console.log(command)
      if (command == "sortByTime") {
        // this.$store.state.sysInit.phone_ChatingSortByTimeFlg = true;
        this.$store.state.sysInit.phone_WaitingSortByTimeFlg = true;
        // this.$store.state.sysInit.phone_EndingSortByTimeFlg = true;
        this.$store.state.sysInit.dropdownSortTitle = "先着順";
      } else {
        //  this.$store.state.sysInit.phone_ChatingSortByTimeFlg = false;
        this.$store.state.sysInit.phone_WaitingSortByTimeFlg = false;
        // this.$store.state.sysInit.phone_EndingSortByTimeFlg = false;
        this.$store.state.sysInit.dropdownSortTitle = "相性順";
      }
    },
    checkIfInternalLine(telNum) {
      return telNum && telNum.length === 5;
    },
    getLineType(telNum) {
      return telNum && telNum.length === 5 ? "内線" : "外線";
    },
    getCustomerName(userInfo) {
      if (userInfo.presence) {
        return VueUtils.computeFullName(userInfo.guestDumyLastName, userInfo.guestDumyFirstName);
      } else {
        return VueUtils.computeFullName(userInfo.lastname, userInfo.firstname);
      }
    },
    getCustomerLogo(userInfo) {
      return userInfo.logo_url
        ? userInfo.logo_url
        : this.$store.state.sysInit.phone_questioner_logo;
    },
    checkIfOutBound(userInfo) {
      return userInfo.is_outbound === "1";
    },
    clickOneCall(callInfo, type) {
      this.categoryList = [];
    },
  },
};
</script>
<style lang="scss">
.wrapper {
  width: 40vw;
}
.wrapper_border {
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: solid;
  border-color: #cccccc;
}
// .intrinsic-aspect-ratio-container {
//   width: 47%;
//   height: 165px;
//   padding: 5px;
//   // padding-bottom: 10%;
//   margin-top: 5px;
//   margin-right: 10px;
//   margin-left: 10px;
//   margin-bottom: 0px;
//   // background-color: lightsalmon;
// }
// .intrinsic-aspect-ratio-container1 {
//   width: 47%;
//   height: 165px;
//   padding: 5px;
//   // padding-bottom: 10%;
//   margin-top: 5px;
//   margin-right: 10px;
//   margin-bottom: 0px;
//   // margin-left: 75px ;
//   // background-color: lightsalmon;
// }
// .intrinsic-aspect-ratio-container1 {
//   width: 47%;
//   height: 165px;
//   padding: 5px;
//   // padding-bottom: 10%;
//   margin-top: 5px;
//   margin-right: 10px;
//   margin-bottom: 0px;
//   // margin-left: 75px ;
//   // background-color: lightsalmon;
// }

// .intrinsic-aspect-ratio-container_summary_2 {
//   width: 47%;
//   height: 155px;
//   padding: 5px;
//   // padding-bottom: 10%;
//   margin-top: 5px;
//   margin-right: 10px;
//   margin-bottom: 0px;
//   // margin-left: 75px ;
//   // background-color: lightsalmon;
// }

.intrinsic-aspect-ratio-container2 {
  width: 47%;
  height: 145px;
  padding: 5px;
  // padding-bottom: 15%;
  margin-top: 5px;
  margin-right: 10px;
  margin-left: 10px;
  margin-bottom: 0px;
  // background-color: lightsalmon;
}
// .intrinsic-aspect-ratio-container2_Summary {
//   width: 95.5%;
//   height: 205px;
//   padding: 5px;
//   // padding-bottom: 15%;
//   margin-top: 5px;
//   margin-right: 10px;
//   margin-left: 10px;
//   margin-bottom: 0px;
//   // background-color: lightsalmon;
// }
// .intrinsic-aspect-ratio-container4 {
//   width: 47%;
//   height: 165px;
//   padding: 5px;
//   // padding-bottom: 15%;
//   margin-top: 5px;
//   margin-right: 10px;
//   margin-bottom: 0px;
//   // background-color: lightsalmon;
// }

.intrinsic-aspect-ratio-container3 {
  width: 150%;
  padding: 10px;
  padding-bottom: 0%;
  margin: 0px;

  // background-color: lightsalmon;
}
.intrinsic-aspect-ratio-container_button_pi4 {
  width: 100%;
  // padding: 10px;
  // padding-bottom: 0%;
  margin-top: 2.15%;

  // background-color: lightsalmon;
}
.intrinsic-aspect-ratio-container_button_pi1 {
  width: 100%;
  padding: 5px;
  padding-bottom: 0%;
  margin-top: 4px;

  // background-color: lightsalmon;
}
.intrinsic-aspect-ratio-container_button_pi2 {
  width: 100%;
  padding: 23.5px;
  padding-bottom: 0%;
  margin-top: 30px;

  // background-color: lightsalmon;
}
.intrinsic-aspect-ratio-container_button_pi3 {
  width: 100%;
  // padding: 10px;
  padding-bottom: 2.75%;
  // margin-top: 37px;

  // background-color: lightsalmon;
}
.intrinsic-aspect-ratio-container_button_div {
  text-align: center;
}
// .pi_title_color {
//   color: #808080;
//   font-size: 15px;
//   font-weight: 800;
//   margin: 12px;
// }
// .pi_text_color {
//   color: #808080;
//   font-size: 16px;
//   font-weight: 400;
//   // margin: 12px;
//   line-height: 30px;
//   padding-left: 12px;
// }
[v-cloak] {
  display: none;
}

.pi_progress {
  width: 50%;
  // display: inline-block;
  text-align: right;
  float: right;
}
// .pi_text_color_progress {
//   color: #808080;
//   font-size: 16px;
//   font-weight: 400;
//   padding-left: 40px;
//   padding-right: 30px;
//   line-height: 45px;
// }
.el-progress {
  width: 80%;
}
.pi_collapse {
  display: inline-block;
  height: 500px;
  overflow: auto;
}
// .el-collapse-item__header {
//     display: -webkit-box;
//     display: -ms-flexbox;
//     display: flex;
//     -webkit-box-align: center;
//     -ms-flex-align: center;
//     align-items: center;
//     height: 48px;
//     line-height: 48px;
//     background-color: #FFF;
//     color: #303133;
//     cursor: pointer;
//      border-bottom: 0px solid #EBEEF5;
//     font-size: 13px;
//     font-weight: 500;
//     -webkit-transition: border-bottom-color .3s;
//     transition: border-bottom-color .3s;
//     outline: 0;
//     background-color: #5ed4ff;
// }
.dialog-data .el-dialog__body {
  padding: 0px;
  .el-table .el-table__cell {
    padding: 0px;
  }
}
.el-tabs .el-tab-pane {
  height: 590px;
}
.img_questioner {
  background-color: #f2f2f2;
  // padding: 5px;
  border-radius: 50%;
  margin-left: 25px;
  width: 45px;
  height: 45px;
}
.img_questioner1 {
  // padding: 5px;
  background-color: #f2f2f2;
  border-radius: 50%;
  margin-left: 15px;
  margin-right: 10px;
  width: 45px;
  height: 45px;
}
.img_operatorPi {
  // padding: 5px;
  border-radius: 50%;
  margin-left: 11px;
  width: 45px;
  height: 45px;
}
.img_splitLine {
  width: 70px;
  height: 2px;
}

.message_presence {
  font-size: 10px;
}
.message_op_name {
  margin-left: 10px;
  font-size: 10px;
}
.message_qu_name {
  margin-left: 24px;
  font-size: 10px;
}
.message_time {
  // margin-left: 15px;
  font-size: 10px;
}
// .el-collapse-item__wrap {
//   height: calc(100% - 45px) !important;
//   overflow: auto !important;
// }

// .el-collapse-item__content {
//   padding-bottom: 0px !important;
//   font-size: 10px !important;
//   color: #303133 !important;
// }
.el-dialog__wrapper2 {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: visible;
  margin: 0;
}
.el-tag1 {
  background-color: #ecf5ff;
  border-color: #d9ecff;
  display: inline-block;
  height: 17px;
  padding: 0 10px;
  line-height: 15px;
  font-size: 10px;
  color: #409eff;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
}
.el-main_pi {
  height: 100%;
  padding: 0px;
}
// .customer-table{
//   height: 160px;
//   overflow:auto;
// }
.intrinsic-aspect-ratio-container2_Summary_call {
  width: 98.5%;
  height: 260px;
  padding: 5px;
  // padding-bottom: 15%;
  margin-top: 5px;
  margin-right: 10px;
  margin-left: 10px;
  margin-bottom: 0px;
  // background-color: lightsalmon;
}
#img_head_back {
  background-color: #ff56a7;
  position: absolute;
  width: 50px;
  left: 647px;
  z-index: 10;
}
#img_head_back_searchDetail {
  background-color: #ff56a7;
  position: absolute;
  width: 50px;
  left: 71.5%;
  z-index: 10;
}
#img_head_back2 {
  background-color: #ff56a7;
  position: absolute;
  width: 60px;
  left: 709px;
  z-index: 10;
}
#img_head_back2_searchDetail {
  background-color: #ff56a7;
  position: absolute;
  width: 60px;
  left: 70%;
  z-index: 10;
}
#img_head_back_table {
  background-color: #ff56a7;
  position: absolute;
  width: 30px;
  left: 7px;
  z-index: 10;
}

.img_heart {
  height: 50px;
  width: 50px;
  position: absolute;
  top: 50px;
  left: 647px;
  z-index: 20;
}
.img_heart_searchDetail {
  height: 50px;
  width: 50px;
  position: absolute;
  top: 50px;
  left: 71.5%;
  z-index: 20;
}
.img_heart2 {
  height: 60px;
  width: 60px;
  position: absolute;
  top: 57px;
  left: 709px;
  z-index: 20;
}
.img_heart2_searchDetail {
  height: 60px;
  width: 60px;
  position: absolute;
  top: 57px;
  left: 70%;
  z-index: 20;
}
.img_heart_table {
  height: 30px;
  width: 30px;
  position: absolute;
  top: 31px;
  left: 7px;
  z-index: 20;
}
.img_heart_table1{
  height: 30px;
  width: 30px;
  position: absolute;
  top: 31px;
  left: 7px;
  z-index: 20;

transition: 1s;
transform: scale(1.1);

}
.element2 {
  width: 70px;
  height: 70px;
  // background-color: #009966;
  border-radius: 50%;
  box-shadow: 0 0 0 10px #00b2f2;
  // margin: auto;
}
.element2-picture1 {
  border-radius: 50%;
  // margin-left: 15px;
  // margin-right: 10px;
  width: 70px;
  height: 70px;
}
.element2-picture2 {
  border-radius: 50%;
  // margin-left: 15px;
  // margin-right: 10px;
  width: 70px;
  height: 70px;
}
.element1 {
  width: 50px;
  height: 50px;
  // background-color: #009966;
  border-radius: 50%;
  box-shadow: 0 0 0 10px #00b2f2;
  // margin: auto;
}
.element1-picture1 {
  border-radius: 50%;
  // margin-left: 15px;
  // margin-right: 10px;
  width: 50px;
  height: 50px;
}
.element1-picture2 {
  border-radius: 50%;
  // margin-left: 15px;
  // margin-right: 10px;
  width: 50px;
  height: 50px;
}
.rectangle1 {
  margin-top: 18px;
  width: 41px;
  height: 5px;
  background: #00b2f2;
}
.rectangle2 {
  margin-top: 18px;
  width: 41px;
  margin-left: 46px;
  height: 5px;
  background: #00b2f2;
}

.rectangle2_1 {
  margin-top: 20px;
  width: 55px;
  height: 5px;
  background: #00b2f2;
}
.rectangle2_2 {
  margin-top: 20px;
  margin-left: 60px;
  width: 55px;
  height: 5px;
  background: #00b2f2;
}

.el-dropdown-link-phone {
  cursor: pointer;
  color: #409eff;
}

.add-new-user-label1 {
  background: #53bce5;
  color: #ffffff;
  height: 30px;
  width: 130px;
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid #ecf5ff;
  position: relative;
  right: 40%;
}
.add-new-user-label2 {
  background: #53bce5;
  color: #ffffff;
  height: 30px;
  width: 130px;
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid #ecf5ff;
  position: relative;
  right: 40%;
}
.add-new-user-input1 {
  width: 98%;
  position: relative;
  top: -27px;
}
.add-new-user-input2 {
  position: relative;
  top: -27px;
}
.el-input__prefix {
  // left: 285px;
  // -webkit-transition: all .3s;
  // transition: all .3s;
  // display:none;
}
// .el-input--prefix .el-input__inner {
//     padding-left: 30px;
// }
.el-icon-platform-eleme {
  // width: 98%;
  // position: relative;
  // top:-27px;
  display: none;
}
.el-table tr td.td-is-left {
  text-align: left;
}
.line-type {
  display: flex;
  zoom: 0.7;
}
.arrow-line {
  display: flex;
  align-items: center;
}
.arrow-icon-right {
  margin-left: -5px;
}
.arrow-icon-left {
  margin-right: -5px;
}
.internal-call-color {
  color: #00b2f2;
}
.external-call-color {
  color: #e6a23c;
}
.veryHighPi{
  color: #039987;
}
.highPi{
  color: #1AA628;
}
.decentPi{
  color: #85980E;
}
.lowPi{
  color: #F14545;
}
</style>
